import { createFileRoute } from "@tanstack/react-router";
import { HowToUseCertificationPage } from "~/components/how-to-use/how-to-use-certification-page";

export const Route = createFileRoute(
  "/$tenantSlug/_protected/apply/how-to-use/$certificationNumber",
)({
  component: TenantHowToUseCertification,
});

function TenantHowToUseCertification() {
  const { certificationNumber } = Route.useParams();
  return <HowToUseCertificationPage certificationNumber={certificationNumber} />;
}
